module.exports = __webpack_public_path__ + "img/pdt_item04.b962ac68.svg";